import React, { useState, useEffect, useContext } from "react";
import { Route, Routes, useNavigate, } from "react-router-dom";
import { useAlert } from 'react-alert'

import { FormField, DropdownQuestion, TermsCheckbox } from "./common_components/NewForms.jsx";
// import { ResearcherContext } from "../../ResearcherContext";
import { NewPrimaryButton } from "../../main_portal/components/common_components/Buttons";
import PurpleTertiaryArrow from "../../../../../assets/images/researcher_app/sign_up/purple_tertiary_arrow.svg";

import { PurpleCompanyExistsModal } from "./common_components/PurpleModals.jsx";


// API Calls
import RegistrationsAPI from "../api/api_calls/RegistrationAPI.js"

function SignUpCard(props) {
    const navigate = useNavigate();
    const alert = useAlert();

    // const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);


    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [submittingPartOne, setSubmittingPartOne] = useState(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [jobRole, setJobRole] = useState("");
    const [howDidYouHear, setHowDidYouHear] = useState("");
    const [submittingPartTwo, setSubmittingPartTwo] = useState(false);

    //Company Exists Modal State
    const [companyModalIsOpen, setCompanyModalIsOpen] = useState(false);
    const toggleModal = () => {
        setCompanyModalIsOpen(!companyModalIsOpen);
    }


    const [errors, setErrors] = useState({});

    function validateEmail(email) {
        const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,61}$/;
        return regex.test(email);
    }

    function onSubmitOne(event) {
        async function checkEmail() {
            setSubmittingPartOne(true)
            const response = await RegistrationsAPI.checkEmail({ email });

            if (response.success) {

                if (response.email_exists) {
                    // Email is already in use
                    alert.show(response.error, { type: 'error' })
                    setSubmittingPartOne(false)
                    return response;

                } else {
                    // Great, email is unique. Proceed to next step.
                    setSubmittingPartOne(false)
                    navigate("user_details")
                }

            } else {
                setSubmittingPartOne(false)
                alert.show("Unable to reach server. Please try again later", { type: 'error' })
            }
            return response;
        }

        event.preventDefault();
        const errors = {};

        if (!email) {
            errors.email = "Email is required";
        } else if (!validateEmail(email)) {
            errors.email = "Email is invalid";
        }
        if (!password) {
            errors.password = "Password is required";
        } else if (password.length < 8) {
            errors.password = "Password must be at least 8 characters";
        }
        if (!agreedToTerms) {
            errors.agreedToTerms = "You must agree to the terms";
        }

        setErrors(errors);

        const rejectForm = Object.keys(errors).length > 0;
        if (rejectForm) {
            return;
        }
        checkEmail();
    }

    function onSubmitTwo(event, request_to_join = false) {
        async function signUp() {
            setSubmittingPartTwo(true)
            const response = await RegistrationsAPI.create({ email, password, firstName, lastName, companyName, jobRole, howHeard: howDidYouHear, request_to_join });

            if (response.success) {

                if (response.company_exists) {
                    if (!response.request_sent) {
                        // Company exists!
                        // Pop the modal
                        setSubmittingPartTwo(false)
                        toggleModal();
                    } else {
                        // Okay, we sent the request.
                        toggleModal();
                        alert.show("Request sent to join company. Stay tuned for an invite!", { type: 'success' })
                    }
                } else {
                    // Company does not exist. You're created.
                    // alert.show("Signed up!", { type: 'success' })
                    setSubmittingPartTwo(false)

                    // Don't need to efresh the researcher context - they're not logged in yet.
                    // Navigate to the signin page and show the email verification popup
                    navigate("/signin", { state: { showEmailVerificationModal: true } })
                }
            } else {
                setSubmittingPartTwo(false)
                alert.show("Unable to reach server. Please try again later", { type: 'error' })
            }
            return response;
        }

        event.preventDefault();
        setErrors({});
        const errors = {};

        if (!firstName) { errors.firstName = "First name is required"; }
        // Last name is optional
        if (!companyName) { errors.companyName = "Company name is required"; }
        if (!jobRole) { errors.jobRole = "Job role is required"; }
        if (!howDidYouHear) { errors.howDidYouHear = "How you heard about us is required"; }

        setErrors(errors);

        const rejectForm = Object.keys(errors).length > 0;
        if (rejectForm) {
            return;
        }

        signUp();
    }

    return (

        <Routes>
            <Route path="/user_details" element={<FormPartTwo firstName={firstName} setFirstName={setFirstName}
                lastName={lastName} setLastName={setLastName}
                companyName={companyName} setCompanyName={setCompanyName}
                jobRole={jobRole} setJobRole={setJobRole}
                howDidYouHear={howDidYouHear} setHowDidYouHear={setHowDidYouHear}
                email={email}
                companyModalIsOpen={companyModalIsOpen} toggleModal={toggleModal}
                errors={errors}
                submitting={submittingPartTwo}
                onSubmit={onSubmitTwo} />} />
            <Route index element={<FormPartOne email={email} setEmail={setEmail}
                password={password} setPassword={setPassword}
                agreedToTerms={agreedToTerms} setAgreedToTerms={setAgreedToTerms}
                errors={errors}
                submitting={submittingPartOne}
                onSubmit={onSubmitOne} />} />
        </Routes>

    )

}

function FormPartOne(props) {

    return (
        <div className="researcher-sign-up-card">
            <div className="researcher-sign-up-card-title-container">
                <div className="researcher-sign-up-card-title">
                    Create a Researcher account
                </div>
                <CardDivider progress="half" />
            </div>
            <form className="researcher-sign-up-form">

                <div className="researcher-sign-up-form-fields">
                    <FormField errorMessage={props.errors["email"]} label="Email" name="email" onChange={(event) => props.setEmail(event.target.value)} placeholder="name@company.com" autoComplete="email" type="email" required={true} />
                    <FormField errorMessage={props.errors["password"]} label="Password" name="password" onChange={(event) => props.setPassword(event.target.value)} placeholder="************" autoComplete="new-password" type="password" required={true} />
                    <TermsCheckbox errorMessage={props.errors["agreedToTerms"]} agreedToTerms={props.agreedToTerms} setAgreedToTerms={props.setAgreedToTerms} />
                </div>
                <div className="researcher-sign-up-form-button-container">
                    <NewPrimaryButton text="Next" buttonType="submit" onClick={(event) => props.onSubmit(event)} submitting={props.submitting} />
                    <div className="researcher-sign-up-tertiary-options-div" >
                        <SignUpPrompt />
                        <UserSignUpPrompt />
                    </div>
                </div>
            </form>
        </div>
    )
}


function FormPartTwo(props) {
    const navigate = useNavigate();
    const jobRoleOptions = ["Product Manager", "Designer", "UX Researcher", "Marketer", "UX Copywriter", "Developer", "Other"];
    const howHeardOptions = ["Conference", "Google (or other search engine)", "Twitter", "Farcaster", "Telegram", "Founder", "Customer / Referral", "Other"]

    // If you navigate directly to this page, go back to the signup page.
    useEffect(() => {
        if (!props.email) {
            navigate("/signup")
        }
    }, [])

    return (
        <div className="researcher-sign-up-card">
            <div className="researcher-sign-up-card-title-container">
                <div className="researcher-sign-up-card-title">
                    Create a Researcher account
                </div>
                <CardDivider progress="full" />
                <div className="researcher-sign-up-card-subtitle">
                    Tell us a bit more about yourself so we can help you get the most out of Despark
                </div>
            </div>
            <form className="researcher-sign-up-form">

                <div className="researcher-sign-up-form-fields">
                    <FormField label="First name" name="first_name" onChange={(event) => props.setFirstName(event.target.value)} placeholder="John" autoComplete="given-name" errorMessage={props.errors["firstName"]} />
                    <FormField label="Last name" name="last_name" onChange={(event) => props.setLastName(event.target.value)} placeholder="Smith" autoComplete="family-name" errorMessage={props.errors["lastName"]} />
                    <FormField label="Company or Organization Name" name="company_name" onChange={(event) => props.setCompanyName(event.target.value)} placeholder="Blockchain Inc." errorMessage={props.errors["companyName"]} />
                    <DropdownQuestion label="Job role" name="job_role" onChange={props.setJobRole} options={jobRoleOptions} placeholder="Select role" errorMessage={props.errors["jobRole"]} />
                    <DropdownQuestion label="How did you hear about us?" name="heard_about" onChange={props.setHowDidYouHear} options={howHeardOptions} placeholder="How did you hear about us?" errorMessage={props.errors["howDidYouHear"]} />
                </div>
                <div className="researcher-sign-up-form-button-container">
                    <NewPrimaryButton text="Sign Up" buttonType="submit" onClick={(event) => props.onSubmit(event)} />
                    <SignUpPrompt />

                </div>
            </form>
            <PurpleCompanyExistsModal isOpen={props.companyModalIsOpen} toggleModal={props.toggleModal} onSubmit={(event) => props.onSubmit(event, true)} companyName={props.companyName} email={props.email} />
        </div>
    )
}


function CardDivider(props) {
    const progressClass = props.progress == "half" ? "researcher-sign-up-progress-bar" : "researcher-sign-up-progress-bar full"
    const emptyProgressClass = props.progress == "half" ? "researcher-sign-up-empty-progress-bar" : "researcher-sign-up-empty-progress-bar none"

    return (
        <div className="researcher-sign-up-card-divider-container" >
            <div className={progressClass} />
            <div className={emptyProgressClass} />
        </div>

    )
}



function SignUpPrompt() {
    const navigate = useNavigate();

    return (
        <div className="researcher-sign-in-prompt-container">
            <div className="researcher-sign-in-prompt-text">
                Already have an account?
            </div>

            <div className="sign-in-prompt-link-container" onClick={() => navigate("/signin")}>
                <div className="researcher-sign-in-prompt-link">Sign in now</div>
                <img className="sign-in-prompt-link-arrow" src={PurpleTertiaryArrow} alt="Decorative purple arrow" />
            </div>

        </div>
    )
}

function UserSignUpPrompt() {
    return (
        <div className="researcher-sign-in-prompt-container">
            <div className="researcher-sign-in-prompt-text">
                Looking to take studies?
            </div>

            <a className="sign-in-prompt-link-container" href="https://app.despark.io/app/signup">
                <div className="researcher-sign-in-prompt-link">Sign up here</div>
                <img className="sign-in-prompt-link-arrow" src={PurpleTertiaryArrow} alt="Decorative purple arrow" />
            </a>

        </div>
    )
}





export default SignUpCard